import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

// "← Wróć" link at the top of project/event detail pages — same look as the back link
// on the McD report detail. Goes to the previous page in history; when the page was
// opened directly (no in-app history), falls back to the home page.
@Component({
  selector: 'app-ph-back-link',
  template: `
    <button type="button" class="ph-back-link" (click)="back()">
      ← {{ 'GLOBAL.back' | translate }}
    </button>
  `,
  styleUrls: ['./ph-back-link.component.scss'],
})
export class PhBackLinkComponent {
  constructor(private location: Location, private router: Router) {}

  back() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }
}
